import { useEffect, useState } from "react";
import axios from "../../utils/axiosInstance"; // تابع axios که قبلا نوشتیم
import { ChevronDown, ChevronUp } from "lucide-react";
import Modal from "../../components/modal/Modal";
import LinearLayout from "../../components/layout/LinearLayout";
import SelectBox from "../../components/edittext/selectbox/SelectBox";
import BasicInput from "../../components/edittext/basicInput/basicInput";
import DocumentPreview from "../../components/DocumentPreview";
const Users = () => {
  const [users, setUsers] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [role, setRole] = useState("");
  const [status, setStatus] = useState("");
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [expanded, setExpanded] = useState(null);
  const [formData, setFormData] = useState({});
  const [note, setNote] = useState("");
  useEffect(() => {
    if (selectedUser) {
      setFormData({
        status: selectedUser.status,
        role: selectedUser.role,
        note: selectedUser.note || "",
      });
    }
  }, [selectedUser]);

  const handleSave = async () => {
    try {
      await axios.put(`/users/${selectedUser._id}`, formData, {
        withCredentials: true,
      });
      loadUsers(); // لیست آپدیت شه
      setModalOpen(false); // مودال بسته شه
    } catch (err) {
      console.error("Error updating user:", err);
    }
  };
  const handleEditUser = (order) => {
    // console.log("brand=", brands);
    setSelectedUser(order);
    setModalOpen(true);
    console.log("selectedUser:", selectedUser);
  };
  const fetchUsers = async ({
    search = "",
    role = "",
    status = "",
    page = 1,
    limit = 10,
  }) => {
    try {
      const response = await axios.get("/users", {
        params: {
          search,
          role,
          status,
          page,
          limit,
        },
      });
      console.log("users:", response.data);
      return response.data; // شامل users و totalCount
    } catch (error) {
      console.error("Error fetching users:", error);
      throw error;
    }
  };
  const loadUsers = async () => {
    try {
      const data = await fetchUsers({
        search,
        role,
        status,
        page,
        limit: perPage,
      });
      setUsers(data.data);
      setTotalCount(data.pagination.total);
      // console.log("users:", data.pagination.total);
    } catch (err) {
      console.error("Error loading users:", err);
    }
  };
  useEffect(() => {
    loadUsers();
  }, [search, role, status, page, perPage]);

  const toggleExpand = (id) => {
    setExpanded(expanded === id ? null : id);
  };

  return (
    <div>
      <h2 className="m-4">Manage Users</h2>
      {/* فیلترها */}
      <div className="d-flex gap-2 m-4">
        <input
          className="form-control"
          placeholder="Search by name/email..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <select
          className="form-select"
          value={role}
          onChange={(e) => setRole(e.target.value)}
        >
          <option value="">All Roles</option>
          <option value="admin">Admin</option>
          <option value="seller">Seller</option>
          <option value="customer">Customer</option>
        </select>

        <select
          className="form-select"
          value={status}
          onChange={(e) => setStatus(e.target.value)}
        >
          <option value="">All Status</option>
          <option value="pending">Pending</option>
          <option value="approved">Approved</option>
          <option value="rejected">Rejected</option>
        </select>

        <select
          className="form-select"
          value={perPage}
          onChange={(e) => setPerPage(Number(e.target.value))}
        >
          {[5, 10, 20, 50].map((n) => (
            <option key={n} value={n}>
              {n} per page
            </option>
          ))}
        </select>
      </div>

      <div className="container-fluid px-2">
        {/* Desktop Table */}
        <div className="d-none d-lg-block m-4">
          <table className="table table-striped w-100 table-hover">
            <thead>
              <tr>
                <th>#</th>
                <th></th>
                <th>Name</th>
                <th>Email</th>
                <th>Role</th>
                <th>Status</th>
                <th>Joined</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user, index) => (
                <tr key={user._id}>
                  <td className="p-3 pt-4">
                    {(page - 1) * perPage + index + 1}
                  </td>
                  <td>
                    <img
                      src={
                        user.profile?.avatar || user.sellerProfile?.avatar
                          ? `${
                              user.profile?.avatar || user.sellerProfile?.avatar
                            }`
                          :`https://res.cloudinary.com/dwuhamihv/image/upload/v1761652467/myshop/profile/og0jxjvu0zjdpkznhadz.png`
                      }
                      alt="Profile"
                      className="rounded-circle border border-0 border-primary"
                      style={{
                        width: "50px",
                        height: "50px",
                        objectFit: "cover",
                      }}
                    />
                  </td>
                  <td className="pt-4">{user.name}</td>
                  <td className="pt-4">{user.email}</td>
                  <td className="pt-4">{user.role}</td>
                  <td className="pt-4">
                    <span
                      className={`badge ${
                        user.status === "approved"
                          ? "bg-success"
                          : user.status === "pending"
                          ? "bg-warning"
                          : "bg-danger"
                      }`}
                    >
                      {user.status}
                    </span>
                  </td>
                  <td className="p-3 pt-4">
                    {new Date(user.createdAt).toLocaleDateString()}
                  </td>
                  <td>
                    <button
                      className="btn btn-sm btn-primary me-1"
                      onClick={() => handleEditUser(user)}
                    >
                      Edit
                    </button>
                    <button className="btn btn-sm btn-danger">Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination */}
          <div className="d-flex justify-content-between align-items-center mt-3">
            <div>
              Showing {(page - 1) * perPage + 1} to{" "}
              {Math.min(page * perPage, totalCount)} of {totalCount} entries
            </div>
            <div className="btn-group">
              <button
                className="btn btn-secondary"
                disabled={page === 1}
                onClick={() => setPage((prev) => prev - 1)}
              >
                Previous
              </button>
              <button
                className="btn btn-secondary"
                disabled={page * perPage >= totalCount}
                onClick={() => setPage((prev) => prev + 1)}
              >
                Next
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Accordion */}
        <div className="d-lg-none">
          {users.map((user) => (
            <div
              key={user._id}
              className="border rounded mb-3 shadow-sm overflow-hidden"
            >
              <div
                className="d-flex justify-content-between align-items-center p-2 bg-light"
                onClick={() => toggleExpand(user._id)}
                role="button"
              >
                <div>
                  <img
                    src={
                      user.profile?.avatar || user.sellerProfile?.avatar
                        ? `${
                            user.profile?.avatar || user.sellerProfile?.avatar
                          }`
                        : `https://res.cloudinary.com/dwuhamihv/image/upload/v1761652467/myshop/profile/og0jxjvu0zjdpkznhadz.png`
                    }
                    alt="Profile"
                    className="rounded-circle border border-0 border-primary m-1 me-2"
                    style={{
                      width: "50px",
                      height: "50px",
                      objectFit: "cover",
                    }}
                  />
                  <strong>{user.name}</strong>
                  <div className="small text-muted">{user.email}</div>
                </div>
                {expanded === user._id ? <ChevronUp /> : <ChevronDown />}
              </div>

              {expanded === user._id && (
                <div className="p-2 small bg-white">
                  <div>
                    <strong>Role:</strong> {user.role}
                  </div>
                  <div>
                    <strong>Status:</strong>{" "}
                    <span
                      className={`badge ${
                        user.status === "approved"
                          ? "bg-success"
                          : user.status === "pending"
                          ? "bg-warning"
                          : "bg-danger"
                      }`}
                    >
                      {user.status}
                    </span>
                  </div>
                  <div>
                    <strong>Joined:</strong>{" "}
                    {new Date(user.createdAt).toLocaleDateString()}
                  </div>
                  <div className="mt-2">
                    <button
                      className="btn btn-sm btn-outline-primary me-1"
                      onClick={() => handleEditUser(user)}
                    >
                      Edit
                    </button>
                    <button className="btn btn-sm btn-outline-danger">
                      Delete
                    </button>
                  </div>
                </div>
              )}
            </div>
          ))}
          {/* Pagination mobile */}
          <div className="btn-group">
            <button
              className="btn btn-secondary"
              disabled={page === 1}
              onClick={() => setPage((prev) => prev - 1)}
            >
              Previous
            </button>
            <button
              className="btn btn-secondary"
              disabled={page * perPage >= totalCount}
              onClick={() => setPage((prev) => prev + 1)}
            >
              Next
            </button>
          </div>
          <div className="mt-2">
            Showing {(page - 1) * perPage + 1} to{" "}
            {Math.min(page * perPage, totalCount)} of {totalCount} entries
          </div>
        </div>
      </div>
      {selectedUser && (
        <Modal show={modalOpen} modalClosed={() => setModalOpen(false)}>
          <div style={{ overflowY: "auto", maxHeight: "80vh" }}>
            <LinearLayout orientation="vertical" gap={2}>
              <LinearLayout width="match-parent" xgravity="center">
                {" "}
                <img
                  src={
                    selectedUser.profile?.avatar ||
                    selectedUser.sellerProfile?.avatar
                      ? `${
                          selectedUser.profile?.avatar ||
                          selectedUser.sellerProfile?.avatar
                        }`
                      : `https://res.cloudinary.com/dwuhamihv/image/upload/v1761652467/myshop/profile/og0jxjvu0zjdpkznhadz.png`
                  }
                  alt="Profile"
                  className="rounded-circle border border-0 border-primary"
                  style={{
                    width: "150px",
                    height: "150px",
                    objectFit: "cover",
                  }}
                />
              </LinearLayout>

              <h6 className="m-1">Name: {selectedUser.name}</h6>
              <h6 className="m-1">Email: {selectedUser.email}</h6>
              <h6 className="m-1">Phone: {selectedUser.phone}</h6>
              <h6 className="m-1">Role: {selectedUser.role}</h6>
              <h6 className="m-1">
                isActive: {selectedUser.isActive ? "Active ✅" : "Inactive ❌"}
              </h6>

              {selectedUser.role === "seller" ? (
                <LinearLayout gap={2}>
                  <h6 className="m-1">
                    CompanyName:{" "}
                    {selectedUser.sellerProfile?.companyName || "-"}
                  </h6>
                  <h6 className="m-1">
                    NationalId: {selectedUser.sellerProfile?.nationalId || "-"}
                  </h6>
                  <h6 className="m-1">
                    Description:{" "}
                    {selectedUser.sellerProfile?.description || "-"}
                  </h6>
                  <div>
                    <h6>Vendor Document:</h6>
                    <DocumentPreview docs={selectedUser.vendorDocs || []} />

                    {/* {(selectedUser.vendorDocs || []).map((d, i) => (
                      <div key={i} className="mb-2">
                        <a
                          href={`${process.env.REACT_APP_API_BASE_URL}${d.url}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {d.filename}
                        </a>
                      </div>
                    ))} */}
                  </div>
                </LinearLayout>
              ) : (
                <LinearLayout>
                  <h6 className="m-1">
                    Address: {selectedUser.profile?.address || "-"}
                  </h6>
                </LinearLayout>
              )}
              <LinearLayout width="wrap-content" orientation="vertical">
                <SelectBox
                  value={formData.status || "pending"}
                  onChange={(value) =>
                    setFormData({ ...formData, status: value })
                  }
                  array={[
                    { _id: "pending", name: "pending" },
                    { _id: "approved", name: "approved" },
                    { _id: "rejected", name: "rejected" },
                  ]}
                  text="Change User Status:"
                  bcolor="primary"
                  textcolor="dark"
                  bgcolor="white"
                  margin="2"
                />

                <SelectBox
                  value={formData.role || "customer"}
                  onChange={(value) =>
                    setFormData({ ...formData, role: value })
                  }
                  array={[
                    { _id: "customer", name: "customer" },
                    { _id: "seller", name: "seller" },
                    { _id: "support", name: "support" },
                    { _id: "admin", name: "admin" },
                  ]}
                  text="Change User Role:"
                  bcolor="primary"
                  textcolor="dark"
                  bgcolor="white"
                  margin="2"
                />

                <BasicInput
                  bsize="1"
                  bcolor="primary"
                  margin="2"
                  bgcolor="white"
                  textcolor="black"
                  scolor="primary"
                  text="Note"
                  value={formData.note}
                  onChange={(value) =>
                    setFormData({ ...formData, note: value })
                  }
                />
              </LinearLayout>

              <button className="btn btn-success mt-3" onClick={handleSave}>
                Save Changes
              </button>
            </LinearLayout>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default Users;

